import { useState, useEffect, useCallback, useMemo } from "react";
import { FileDown, Plus, Send, RefreshCcw, AlertTriangle } from "lucide-react";
import DriversTable from "./DriversTable";
import DriverKycTable from "./DriverKycTable";
import TeamDropdown from "../Utils/TeamDropdown";
import DriverTaskTable from "./DriverTaskTable";
import { exportAnyJsonToExcel } from "../Utils/exportAnyJsonToExcel";
import { Toaster, toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";
import AddDriverModal from "./AddDriverModal";
import LoadingScreen from "../Utils/LoadingScreen";
import * as Dialog from "@radix-ui/react-dialog";
import EditDriverModal from "./EditDriverModal";
import SendNotificationModal from "./SendNotificationModal";
import BulkSendNotificationModal from "./BulkSendNotificationModal";
import ViewKycDetails from "./ViewKycDetails";
import EditKycModal from "./EditKycModal";
import TablePagination from "../Utils/TablePagination";
import DriverConfigModal from "./DriverConfigModal";
import DriverDetailsModal from "./DriverDetailsModal";
import DriverConfigTable from "./DriverConfigTable";
import DriverConfigQuickAddModal from "./DriverConfigQuickAddModal";
import DriverChargesBoard from "./DriverChargesBoard";
import DriverChargesModal from "./DriverChargesModal";
import PrimaryTeamModal from "./PrimaryTeamModal";
import AssignTeamsModal from "./AssignTeamsModal";
import useDriver from "../../Sevices/Driver Api/useDriver";
import useDriverTeams from "../../Sevices/Driver Api/useDriverTeams";
import useDriverCharges from "../../Sevices/Driver Api/useDriverCharges";
import useDriverConfig from "../../Sevices/Driver Api/useDriverConfig";
import useDriverKYC from "../../Sevices/Driver Api/useDriverKYC";
import useNotification from "../../Sevices/useNotification";
import useKYCImageUpload from "../../Sevices/Driver Api/useKYCImageUpload";
import PackerTaskConfigModal from "./PackerTaskConfigModal";
import usePackerTaskConfig from "../../Sevices/Driver Api/usePackerTaskConfig";

export default function DriversPage() {
  const { baseurl, token, setIsUnauthorised, AdminId, api } =
    useGlobalContext();
  const {
    drivers,
    loading,
    fetchDrivers,
    toggleDutyStatus,
    editDriverApi,
    updateDriverDutyApi,
    deactivateActivateDriverApi,
  } = useDriver();

  const {
    teams,
    teamsLoading,
    fetchDriverTeams,
    fetchDriverMultipleTeams,
    updateDriverActiveTeam,
    insertDriverMultipleTeams,
    deleteDriverMultipleTeams,
  } = useDriverTeams();

  const { chargeRows, fetchDriverCharges } = useDriverCharges();

  const {
    configRows,
    configLoading,
    fetchAllDriverConfigs,
    handleDeleteConfig,
    fetchDriverConfigByCode,
    fetchDriverConfigForQuickAdd,
    saveDriverQuickConfig,
    deleteDriverQuickConfig,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteDriverConfig,
  } = useDriverConfig();

  const {
    getPackerTaskConfig,
    savePackerTaskConfig,
    getAllPackerTask,
    updateDriverPackerStatus,
  } = usePackerTaskConfig();

  const {
    kycDrivers,
    fetchDriverKycDetails,
    handleKycAction,
    handleStepSubmit,
  } = useDriverKYC();

  const { uploadImageToServer } = useKYCImageUpload();
  const { sendNotification } = useNotification();

  const today = new Date();
  const todayDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  const year = today.getFullYear();
  const month = today.getMonth();
  // 0-index
  const [Loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [editKycModalOpen, setEditKycModalOpen] = useState(false);
  const [editDriver, setEditDriver] = useState(null);
  const [notificationDriver, setNotificationDriver] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [editKycDriver, setEditKycDriver] = useState(null);
  const [kycStatusLoading, setKycStatusLoading] = useState(false);
  const [openKycDialogId, setOpenKycDialogId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [driverKycStatus, setDriverKycStatus] = useState(null);
  const [driverTabLoading, setDriverTabLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [kycFormdata, setKycFormData] = useState({
    driver_code: "",
    email: "",
    phone: "",
    aadhaar_no: "",
    pan_no: "",
    driving_licence: "",
    transport_type_id: "",
    transport_description: "",
    licence_plate: "",
    city: "",
    area: "",
    pinCode: "",
    pinCodeId: "",
    profile_photo: null,
    aadhaar_front: null,
    aadhaar_back: null,
    pan_front: null,
    driving_licence_img: null,
    vehicle_name_plate_img: null,
  });
  const [kycTabLoading, setKycTabLoading] = useState(false);
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [configDriverCode, setConfigDriverCode] = useState("");

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [detailsDriver, setDetailsDriver] = useState(null);
  const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
  const [statusDriver, setStatusDriver] = useState(null);
  const [statusSubmitting, setStatusSubmitting] = useState(false);

  const [deletingConfigId, setDeletingConfigId] = useState(null);
  const [configSearch, setConfigSearch] = useState("");
  const [quickConfigOpen, setQuickConfigOpen] = useState(false);
  const [chargesModalOpen, setChargesModalOpen] = useState(false);
  const [chargesDriverCode, setChargesDriverCode] = useState(""); // for edit-from-card

  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const [teamDriverId, setTeamDriverId] = useState(null);
  const [assignTeamsOpen, setAssignTeamsOpen] = useState(false);
  const [primaryTeamOpen, setPrimaryTeamOpen] = useState(false);
  const [driverExistingTeams, setDriverExistingTeams] = useState([]);
  const [selectedDriverForTeams, setSelectedDriverForTeams] = useState(null);
  const [assignTeamDriverObj, setAssignTeamDriverObj] = useState(null);

  const [packerTaskConfigOpen, setPackerTaskConfigOpen] = useState(false);
  const [packerUpdatingId, setPackerUpdatingId] = useState(null);
  const [packerStatusMap, setPackerStatusMap] = useState({});
  const [packerTasks, setPackerTasks] = useState([]);
  const [packerTasksLoading, setPackerTasksLoading] = useState(false);

  const [packerTaskFilters, setPackerTaskFilters] = useState({
    driverId: "",
    fromDate: todayDate,
    toDate: todayDate,
  });

  const driversPerPage = 25;
  const configPerPage = 15;
  const [configPage, setConfigPage] = useState(1);

  const selectedTeamDriverCodes = useMemo(() => {
    if (!selectedTeam) return null;

    const teamObj = teams.find((t) => t.team_name === selectedTeam);

    if (!teamObj || !Array.isArray(teamObj.driverlist)) return null;

    return new Set(teamObj.driverlist.map((d) => d.driver_code));
  }, [teams, selectedTeam]);

  const filteredDrivers = drivers.filter((driver) => {
    const matchSearch =
      driver.fullName?.toLowerCase().includes(search.toLowerCase()) ||
      driver.username?.toLowerCase().includes(search.toLowerCase());

    const matchTeam = selectedTeamDriverCodes
      ? selectedTeamDriverCodes.has(driver.driverId || driver.driver_code)
      : true;

    const matchStatus = selectedStatus
      ? driver.status === selectedStatus
      : true;

    return matchSearch && matchTeam && matchStatus;
  });

  const fetchPackerTasks = useCallback(async () => {
    try {
      setPackerTasksLoading(true);

      const data = await getAllPackerTask({
        driverId: packerTaskFilters.driverId,
        fromDate: packerTaskFilters.fromDate,
        toDate: packerTaskFilters.toDate,
      });

      setPackerTasks(Array.isArray(data) ? data : []);
    } finally {
      setPackerTasksLoading(false);
    }
  }, [getAllPackerTask, packerTaskFilters]);

  useEffect(() => {
    const loadDriversTab = async () => {
      if (!AdminId) return;

      try {
        setDriverTabLoading(true);
        await Promise.all([fetchDrivers(true), fetchDriverTeams()]);
      } finally {
        setDriverTabLoading(false);
      }
    };

    loadDriversTab();
  }, [AdminId]);

  useEffect(() => {
    if (activeTab === "Packer Tasks") {
      fetchPackerTasks();
    }
  }, [activeTab]);

  useEffect(() => {
    setConfigPage(1);
  }, [configSearch]);

  const filteredKycDrivers = kycDrivers?.filter((driver) => {
    const searchLower = search.toLowerCase();
    return [
      driver.name,
      driver.email,
      driver.driver_code,
      driver.aadhaar_no,
      driver.area,
      driver.city,
      driver.driving_licence,
      driver.licence_plate,
      driver.pan_no,
      driver.phone,
      driver.transport_description,
      driver.transport_type_id,
    ].some((field) => field?.toLowerCase().includes(searchLower));
  });

  const indexOfLast = currentPage * driversPerPage;
  const indexOfFirst = indexOfLast - driversPerPage;
  const currentDrivers = filteredDrivers?.slice(indexOfFirst, indexOfLast);
  const currentKycDrivers = filteredKycDrivers?.slice(
    indexOfFirst,
    indexOfLast,
  );

  useEffect(() => {
    if (editKycDriver && editKycModalOpen) {
      setKycFormData({
        driver_code: editKycDriver.driverId || editKycDriver.driver_code || "",
        email: editKycDriver.email || "",
        phone: editKycDriver.phone || "",
        city: editKycDriver.city || "",
        area: editKycDriver.area || "",
        pinCode:
          editKycDriver.pinCode ||
          editKycDriver.pin_code ||
          editKycDriver.pincode ||
          "",
        pinCodeId:
          editKycDriver.pinCodeId ||
          editKycDriver.pin_code_id ||
          editKycDriver.pincode_id ||
          editKycDriver.pinCode ||
          "",
        profile_photo:
          editKycDriver.profilePicture || editKycDriver.profile_photo || null,
        aadhaar_no:
          editKycDriver.aadharNumber || editKycDriver.aadhaar_no || "",
        aadhaar_front:
          editKycDriver.aadharFrontPhoto || editKycDriver.aadhaar_front || null,
        aadhaar_back:
          editKycDriver.aadharBackPhoto || editKycDriver.aadhaar_back || null,
        pan_no: editKycDriver.panCard || editKycDriver.pan_no || "",
        pan_front:
          editKycDriver.panCardFrontPhoto || editKycDriver.pan_front || null,
        driving_licence:
          editKycDriver.drivingLicenseNumber ||
          editKycDriver.driving_licence ||
          "",
        driving_licence_img:
          editKycDriver.drivingLicenseFrontPhoto ||
          editKycDriver.driving_licence_img ||
          null,
        transport_type_id:
          editKycDriver.transportTypeID ||
          editKycDriver.transport_type_id ||
          "",
        transport_description:
          editKycDriver.transportDescription ||
          editKycDriver.transport_description ||
          "",
        licence_plate:
          editKycDriver.licensePlate || editKycDriver.licence_plate || "",
        vehicle_name_plate_img:
          editKycDriver.licensePlatePhoto ||
          editKycDriver.vehicle_name_plate_img ||
          null,
      });
      setCurrentStep(1);
    }
  }, [editKycDriver, editKycModalOpen]);

  const handleFileChange = (fieldName, file) => {
    setKycFormData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };

  const getPincodeDetails = useCallback(
    async ({ word, pageSize = 20, nextToken = "", previousToken = "" }) => {
      const cleanWord = String(word || "").trim();

      if (!cleanWord) {
        return null;
      }

      try {
        const res = await api.post(
          "/api/Admin/v1.0/getPincodeDetails",
          {
            word: cleanWord,
            pageSize,
            nextToken,
            previousToken,
          },
          {
            headers: {
              accept: "*/*",
              "Content-Type": "application/json-patch+json",
            },
          },
        );

        if (res.data?.responseCode === "00") {
          return res.data;
        }

        if (
          res.data?.responseCode !== "02" &&
          res.data?.responseCode !== "03" &&
          res.data?.responseCode !== "98" &&
          res.data?.responseCode !== "401"
        ) {
          toast.error(res.data?.responseMessage || "Unable to fetch pincodes");
        }

        return null;
      } catch (error) {
        console.error("getPincodeDetails error:", error);

        toast.error(
          error?.response?.data?.responseMessage || "Error fetching pincodes",
        );

        return null;
      }
    },
    [api],
  );

  const filteredConfigRows = (configRows || []).filter((r) => {
    const q = configSearch.trim().toLowerCase();
    if (!q) return true;

    return [
      r.driver_code,
      r.name,
      r.team_name,
      r.driver_type,
      String(r.cash_limit ?? ""),
      String(r.daily_task_limit ?? ""),
    ].some((v) =>
      String(v || "")
        .toLowerCase()
        .includes(q),
    );
  });

  const configIndexOfLast = configPage * configPerPage;
  const configIndexOfFirst = configIndexOfLast - configPerPage;
  const currentConfigRows = filteredConfigRows.slice(
    configIndexOfFirst,
    configIndexOfLast,
  );

  const handleDriverSelect = (e) => {
    const selectedDriverCode = e.target.value;
    const selectedDriver = drivers.find(
      (driver) => driver.driverId === selectedDriverCode,
    );

    if (selectedDriver) {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: selectedDriverCode,
        email: selectedDriver.email || "",
        phone: selectedDriver.phone || "",
      }));
    } else {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: "",
        email: "",
        phone: "",
      }));
    }
  };

  const resetForm = () => {
    setKycFormData({
      driver_code: "",
      email: "",
      phone: "",
      aadhaar_no: "",
      pan_no: "",
      driving_licence: "",
      transport_type_id: "",
      transport_description: "",
      licence_plate: "",
      city: "",
      area: "",
      pinCode: "",
      pinCodeId: "",
      profile_photo: null,
      aadhaar_front: null,
      aadhaar_back: null,
      pan_front: null,
      driving_licence_img: null,
      vehicle_name_plate_img: null,
    });
  };
  const closeModel = () => {
    setOpenKycDialogId(null);
    setSelectedDriver(null);
    setDriverKycStatus(null);
  };

  const populateEditForm = (driver) => {
    setKycFormData({
      driver_code: driver.driver_code || "",
      email: driver.email || "",
      phone: driver.phone || "",
      aadhaar_no: driver.aadhaar_no || "",
      pan_no: driver.pan_no || "",
      driving_licence: driver.driving_licence || "",
      transport_type_id: driver.transport_type_id || "",
      transport_description: driver.transport_description || "",
      licence_plate: driver.licence_plate || "",
      city: driver.city || "",
      area: driver.area || "",
      pinCode: driver.pinCode || driver.pin_code || driver.pincode || "",
      pinCodeId:
        driver.pinCodeId ||
        driver.pin_code_id ||
        driver.pincode_id ||
        driver.pinCode ||
        "",
      profile_photo: driver.profile_photo || null,
      aadhaar_front: driver.aadhaar_front || null,
      aadhaar_back: driver.aadhaar_back || null,
      pan_front: driver.pan_front || null,
      driving_licence_img: driver.driving_licence_img || null,
      vehicle_name_plate_img: driver.vehicle_name_plate_img || null,
    });
    setEditKycModalOpen(true);
    setEditKycDriver(driver);
  };

  useEffect(() => {
    const loadKycDetails = async () => {
      if (activeTab !== "Kyc Details" || !AdminId) return;

      try {
        setKycTabLoading(true);
        await fetchDriverKycDetails();
      } finally {
        setKycTabLoading(false);
      }
    };

    loadKycDetails();
  }, [activeTab, AdminId]);

  useEffect(() => {
    if (activeTab === "Configuration" && AdminId) {
      fetchAllDriverConfigs();
    }
  }, [activeTab, AdminId]);

  const formatDateTime = (value) => {
    if (!value) return "-";
    try {
      const date = new Date(value);
      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return value;
    }
  };

  const formatTaskDuration = (value) => {
    if (!value) return "-";

    const totalSeconds = Number(String(value).replace("s", ""));

    if (Number.isNaN(totalSeconds)) {
      return value;
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }

    return `${minutes}m ${seconds}s`;
  };

  const formatAmount = (value) => {
    const amount = Number(value);

    if (Number.isNaN(amount)) {
      return "₹0";
    }

    return amount.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    });
  };

  const getTaskStatusColor = (status) => {
    const normalizedStatus = String(status || "").toLowerCase();

    if (normalizedStatus === "completed" || normalizedStatus === "delivered") {
      return "bg-green-100 text-green-700";
    }

    if (normalizedStatus === "cancelled" || normalizedStatus === "rejected") {
      return "bg-red-100 text-red-700";
    }

    if (normalizedStatus === "assigned" || normalizedStatus === "accepted") {
      return "bg-blue-100 text-blue-700";
    }

    if (normalizedStatus === "in_progress" || normalizedStatus === "picked") {
      return "bg-purple-100 text-purple-700";
    }

    return "bg-orange-100 text-orange-700";
  };

  const getDriverCode = (driver) =>
    String(driver?.driverId || driver?.driver_code || "").trim();

  const getDriverPackerStatus = (driver) => {
    const driverCode = getDriverCode(driver);

    // API update ke turant baad temporary local value
    if (Object.prototype.hasOwnProperty.call(packerStatusMap, driverCode)) {
      return packerStatusMap[driverCode];
    }

    // Actual driver-list API response
    const rawStatus =
      driver?.is_active_for_packer ??
      driver?.packer_status ??
      driver?.packerStatus ??
      driver?.is_packer ??
      driver?.isPacker ??
      "N";

    const normalizedStatus = String(rawStatus).trim().toUpperCase();

    return ["Y", "1", "TRUE", "ACTIVE"].includes(normalizedStatus) ? "Y" : "N";
  };

  const getAssignedTaskDriver = (task) => {
    const taskDriverId = task?.driver_id;

    if (
      taskDriverId === null ||
      taskDriverId === undefined ||
      taskDriverId === ""
    ) {
      return null;
    }

    return (
      drivers.find((driver) => {
        const possibleDriverIds = [
          driver?.id,
          driver?.pk_driver_id,
          driver?.driver_id,
          driver?.driverId,
          driver?.driver_code,
        ]
          .filter((value) => value !== null && value !== undefined)
          .map(String);

        return possibleDriverIds.includes(String(taskDriverId));
      }) || null
    );
  };

  const handlePackerStatusChange = async (driver) => {
    const driverCode = getDriverCode(driver);

    if (!driverCode || packerUpdatingId) return;

    const currentStatus = getDriverPackerStatus(driver);
    const nextStatus = currentStatus === "Y" ? "N" : "Y";

    try {
      setPackerUpdatingId(driverCode);

      const success = await updateDriverPackerStatus(driverCode, nextStatus);

      if (success) {
        setPackerStatusMap((previous) => ({
          ...previous,
          [driverCode]: nextStatus,
        }));

        await fetchDrivers(true);
      }
    } finally {
      setPackerUpdatingId(null);
    }
  };

  const renderTabNavigation = () => (
    <div className="mb-4 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        <button
          onClick={() => setActiveTab("list")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "list"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Driver
        </button>
        <button
          onClick={() => setActiveTab("Kyc Details")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Kyc Details"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Kyc Details
        </button>
        <button
          onClick={() => setActiveTab("Configuration")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Configuration"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Configuration
        </button>
        <button
          onClick={() => setActiveTab("Packer Tasks")}
          className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
            activeTab === "Packer Tasks"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Packer Tasks
        </button>
      </nav>
    </div>
  );

  const renderSearchAndFilters = () => (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
      <div className="flex flex-wrap items-end gap-2">
        {activeTab !== "Configuration" ? (
          <input
            // type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={
              activeTab === "Kyc Details"
                ? "Search by email or drive code..."
                : "Search name or username..."
            }
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        ) : (
          <input
            type="text"
            value={configSearch}
            onChange={(e) => setConfigSearch(e.target.value)}
            placeholder="Search config by driver code, name, team..."
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        )}
      </div>

      {activeTab === "list" && renderDriverActions()}
      {activeTab === "Kyc Details" && renderKycActions()}

      {activeTab === "Configuration" && (
        <div className="flex flex-wrap items-end gap-2">
          <button
            className="flex items-center space-x-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => {
              setChargesDriverCode("");
              setChargesModalOpen(true);
            }}
          >
            <Plus size={14} />
            <span>Add Charges</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => setQuickConfigOpen(true)}
          >
            <Plus size={14} />
            <span>Add Config</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => setPackerTaskConfigOpen(true)}
          >
            <Plus size={14} />
            <span>Task Config</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => fetchAllDriverConfigs()}
          >
            <RefreshCcw size={14} />
            <span>Refresh</span>
          </button>
        </div>
      )}
    </div>
  );

  const renderDriverActions = () => (
    <div className="flex flex-wrap text-[12px] items-end gap-2">
      <div className="w-[180px]">
        <TeamDropdown
          teams={(teams || []).map((t) => ({
            id: t.id || t.Id,
            team_name: t.team_name || t.teamName,
          }))}
          value={
            teams.find((t) => (t.team_name || t.teamName) === selectedTeam)
              ?.id || ""
          }
          onChange={(id) => {
            const selected = teams.find(
              (t) => String(t.id || t.Id) === String(id),
            );

            setSelectedTeam(selected?.team_name || selected?.teamName || "");
          }}
          loading={teamsLoading}
          placeholder="All Teams"
        />
      </div>

      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="offline">Offline</option>
      </select>

      <button
        className="flex items-center space-x-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() =>
          exportAnyJsonToExcel({
            data: drivers,
            filePrefix: "DriversExport",
            sheetName: "DriversList",
          })
        }
      >
        <FileDown size={14} />
        <span>Export</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setModalOpen(true)}
      >
        <Plus size={14} />
        <span>Add Driver</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setBulkOpen(true)}
      >
        <Send size={14} />
        <span>Send Bulk</span>
      </button>

      {/* <button className="flex items-center space-x-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 rounded text-xs shadow">
        <Bell size={14} />
        <span>Push</span>
      </button> */}

      <button
        className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={async () => {
          try {
            setDriverTabLoading(true);
            await fetchDrivers(true);
          } finally {
            setDriverTabLoading(false);
          }
        }}
      >
        <RefreshCcw size={14} />
        <span>Refresh</span>
      </button>
    </div>
  );

  const renderKycActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => {
          setEditKycDriver(null);
          resetForm();
          setCurrentStep(1);
          setEditKycModalOpen(true);
        }}
      >
        <Plus size={14} />
        <span>Add KYC</span>
      </button>
    </div>
  );

  const renderPagination = () => {
    const totalCount =
      activeTab === "list"
        ? filteredDrivers?.length || 0
        : filteredKycDrivers?.length || 0;

    return (
      <TablePagination
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={driversPerPage}
        onPageChange={setCurrentPage}
      />
    );
  };

  const renderModals = () => {
    const isAnyModalOpen =
      modalOpen ||
      editModalOpen ||
      statusConfirmOpen ||
      notificationModalOpen ||
      bulkOpen ||
      editKycModalOpen ||
      !!selectedDriver ||
      configModalOpen ||
      detailsModalOpen ||
      quickConfigOpen ||
      packerTaskConfigOpen ||
      chargesModalOpen ||
      assignTeamsOpen ||
      primaryTeamOpen;

    if (!isAnyModalOpen) return null;

    return (
      <>
        <AddDriverModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          Refesh={fetchDrivers}
          AdminId={AdminId}
        />
        <EditDriverModal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          driver={editDriver}
          teams={teams}
          onDriverUpdated={() => fetchDrivers()}
          editDriverApi={editDriverApi}
          updateDriverDutyApi={updateDriverDutyApi}
        />

        <AssignTeamsModal
          isOpen={assignTeamsOpen}
          onClose={() => setAssignTeamsOpen(false)}
          driverId={selectedDriverForTeams}
          teams={teams}
          driver={assignTeamDriverObj}
          fetchDriverMultipleTeams={fetchDriverMultipleTeams}
          updateDriverActiveTeam={updateDriverActiveTeam}
          deleteDriverMultipleTeams={deleteDriverMultipleTeams}
          onNext={(driverId, teamIds, existingTeams) => {
            setSelectedDriverForTeams(driverId);
            setTeamDriverId(driverId);
            setSelectedTeamIds(teamIds);
            setDriverExistingTeams(existingTeams);
            setAssignTeamsOpen(false);
            setPrimaryTeamOpen(true);
          }}
        />

        <PrimaryTeamModal
          isOpen={primaryTeamOpen}
          onClose={() => {
            setPrimaryTeamOpen(false);
            setSelectedTeamIds([]);
            setDriverExistingTeams([]);
            setSelectedDriverForTeams(null);
            setTeamDriverId(null);
          }}
          selectedTeams={(() => {
            const apiTeamsMap = new Map(
              driverExistingTeams.map((t) => [
                String(t.teamId || t.team_id || t.id).trim(),
                {
                  id: String(t.teamId || t.team_id || t.id).trim(),
                  teamId: t.teamId || t.team_id || t.id,
                  team_name: t.teamName || t.team_name,
                  teamName: t.teamName || t.team_name,
                  isPrimary: t.isPrimary,
                  isActive: t.isActive,
                },
              ]),
            );

            const newlySelectedTeams = teams
              .filter((t) => {
                const sid = String(t.id).trim();
                return selectedTeamIds.includes(sid) && !apiTeamsMap.has(sid);
              })
              .map((t) => ({
                id: String(t.id).trim(),
                teamId: t.id,
                team_name: t.team_name || t.teamName,
                teamName: t.team_name || t.teamName,
                isPrimary: "N",
                isActive: "Y",
              }));

            const allSelectedTeams = [
              ...Array.from(apiTeamsMap.values()),
              ...newlySelectedTeams,
            ];

            return allSelectedTeams;
          })()}
          onConfirm={async (primaryId) => {
            if (!teamDriverId) {
              toast.error("Driver ID missing!");
              console.error(" teamDriverId is null or undefined");
              return;
            }

            const success = await insertDriverMultipleTeams({
              driverId: teamDriverId,
              adminId: AdminId,
              teamIds: selectedTeamIds,
              primaryTeamId: primaryId,
            });

            if (success) {
              setPrimaryTeamOpen(false);
              await new Promise((resolve) => setTimeout(resolve, 500));

              // Refresh driver teams
              const updatedTeams = await fetchDriverMultipleTeams(teamDriverId);

              // Update state
              setDriverExistingTeams(updatedTeams);
              await fetchDrivers(true);
              await fetchDriverTeams();

              // Reset
              setSelectedTeamIds([]);
              setDriverExistingTeams([]);
              setSelectedDriverForTeams(null);
              setTeamDriverId(null);

              toast.success("Teams assigned successfully!");
            }
          }}
        />

        <SendNotificationModal
          isOpen={notificationModalOpen}
          onClose={() => setNotificationModalOpen(false)}
          driver={notificationDriver}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
          sendSingleNotificationApi={sendNotification}
        />

        <BulkSendNotificationModal
          isOpen={bulkOpen}
          onClose={() => setBulkOpen(false)}
          drivers={drivers}
          baseurl={baseurl}
          teams={teams}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
        />

        <EditKycModal
          editKycModalOpen={editKycModalOpen}
          setEditKycModalOpen={setEditKycModalOpen}
          editKycDriver={editKycDriver}
          setEditKycDriver={setEditKycDriver}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          kycFormdata={kycFormdata}
          setKycFormData={setKycFormData}
          drivers={drivers}
          handleDriverSelect={handleDriverSelect}
          handleFileChange={handleFileChange}
          handleStepSubmit={handleStepSubmit}
          getPincodeDetails={getPincodeDetails}
          uploadImageToServer={uploadImageToServer}
          resetForm={resetForm}
          Loading={Loading}
          onSuccess={() => {
            if (activeTab === "Kyc Details") {
              fetchDriverKycDetails();
            }
          }}
          activeTab={activeTab}
          FetchDriverKycDetails={fetchDriverKycDetails}
          AdminId={AdminId}
        />

        <ViewKycDetails
          selectedDriver={selectedDriver}
          setSelectedDriver={setSelectedDriver}
          driverKycStatus={driverKycStatus}
          setDriverKycStatus={setDriverKycStatus}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          loading={loading}
          setLoading={setLoading}
          kycStatusLoading={kycStatusLoading}
          setKycStatusLoading={setKycStatusLoading}
          openKycDialogId={openKycDialogId}
          setOpenKycDialogId={setOpenKycDialogId}
          closeModel={closeModel}
          activeTab={activeTab}
          kycFormdata={editKycDriver || {}}
          resetForm={resetForm}
          setEditKycModalOpen={setEditKycModalOpen}
          setEditKycDriver={setEditKycDriver}
          setCurrentStep={setCurrentStep}
          updateDriverKycStatus={handleKycAction}
          fetchDriverKycDetails={fetchDriverKycDetails}
          handleStepSubmit={handleStepSubmit}
          configRows={configRows}
          chargeRows={chargeRows}
          AdminId={AdminId}
        />

        <DriverConfigModal
          open={configModalOpen}
          onOpenChange={setConfigModalOpen}
          driverCode={configDriverCode}
          onSuccess={() => {
            if (activeTab === "Configuration") fetchAllDriverConfigs(true);
          }}
          fetchSingleDriverConfig={fetchSingleDriverConfig}
          saveSingleDriverConfig={saveSingleDriverConfig}
          deleteSingleDriverConfig={deleteDriverConfig}
        />

        <DriverDetailsModal
          open={detailsModalOpen}
          onOpenChange={setDetailsModalOpen}
          driver={detailsDriver}
          fetchDriverConfigByCode={fetchDriverConfigByCode}
          onOpenConfig={(driverCode) => {
            setConfigDriverCode(driverCode);
            setConfigModalOpen(true);
          }}
          onEditDriver={(driverObj) => {
            setDetailsModalOpen(false);
            setEditDriver(driverObj);
            setEditModalOpen(true);
          }}
          onToggleDutyStatus={async (driverObj, isCurrentlyOn) => {
            await toggleDutyStatus(driverObj, isCurrentlyOn);

            setDetailsDriver((prev) =>
              prev
                ? {
                    ...prev,
                    dutyStatus: isCurrentlyOn ? "inactive" : "active",
                  }
                : prev,
            );
          }}
          dutyLoading={loading}
        />

        <DriverConfigQuickAddModal
          open={quickConfigOpen}
          onOpenChange={setQuickConfigOpen}
          drivers={drivers}
          onSuccess={() => fetchAllDriverConfigs(true)}
          fetchDriverConfigForQuickAdd={fetchDriverConfigForQuickAdd}
          saveDriverQuickConfig={saveDriverQuickConfig}
          deleteDriverQuickConfig={deleteDriverQuickConfig}
        />

        <DriverChargesModal
          open={chargesModalOpen}
          onOpenChange={setChargesModalOpen}
          adminId={AdminId}
          drivers={drivers}
          initialDriverCode={chargesDriverCode}
          onSuccess={async () => {
            await fetchDriverCharges();
          }}
        />
      </>
    );
  };

  return (
    <div className="h-full flex flex-col overflow-hidden p-4">
      <Toaster position="top-right" />

      <div className="flex justify-between items-center">
        <h1 className="text-xl font-semibold">Drivers</h1>
      </div>

      {renderTabNavigation()}
      {renderSearchAndFilters()}

      <>
        {activeTab === "list" &&
          (driverTabLoading || loading ? (
            <LoadingScreen />
          ) : (
            <DriversTable
              currentDrivers={currentDrivers}
              loading={loading}
              year={year}
              month={month}
              packerUpdatingId={packerUpdatingId}
              getDriverCode={getDriverCode}
              getDriverPackerStatus={getDriverPackerStatus}
              handlePackerStatusChange={handlePackerStatusChange}
              toggleDutyStatus={toggleDutyStatus}
              formatDateTime={formatDateTime}
              setNotificationDriver={setNotificationDriver}
              setNotificationModalOpen={setNotificationModalOpen}
              setDetailsDriver={setDetailsDriver}
              setDetailsModalOpen={setDetailsModalOpen}
              setStatusDriver={setStatusDriver}
              setStatusConfirmOpen={setStatusConfirmOpen}
              setSelectedDriverForTeams={setSelectedDriverForTeams}
              setAssignTeamDriverObj={setAssignTeamDriverObj}
              setAssignTeamsOpen={setAssignTeamsOpen}
            />
          ))}

        {activeTab === "Kyc Details" &&
          (kycTabLoading ? (
            <LoadingScreen />
          ) : (
            <DriverKycTable
              currentKycDrivers={currentKycDrivers}
              setSelectedDriver={setSelectedDriver}
              setOpenKycDialogId={setOpenKycDialogId}
              setEditKycDriver={setEditKycDriver}
              populateEditForm={populateEditForm}
              setEditKycModalOpen={setEditKycModalOpen}
            />
          ))}

        {activeTab === "Configuration" &&
          (configLoading ? (
            <LoadingScreen />
          ) : (
            <>
              <DriverConfigTable
                rows={currentConfigRows}
                deletingId={deletingConfigId}
                onEdit={(driverCode) => {
                  setConfigDriverCode(driverCode);
                  setConfigModalOpen(true);
                }}
                onDelete={handleDeleteConfig}
              />

              <TablePagination
                currentPage={configPage}
                totalCount={filteredConfigRows.length}
                pageSize={configPerPage}
                onPageChange={setConfigPage}
              />
            </>
          ))}

        {activeTab === "list" &&
          !driverTabLoading &&
          !loading &&
          renderPagination()}
        {activeTab === "Kyc Details" && !kycTabLoading && renderPagination()}

        {/* Task Table */}
        <DriverTaskTable
          activeTab={activeTab}
          drivers={drivers}
          packerTaskFilters={packerTaskFilters}
          setPackerTaskFilters={setPackerTaskFilters}
          fetchPackerTasks={fetchPackerTasks}
          packerTasksLoading={packerTasksLoading}
          packerTasks={packerTasks}
          getAssignedTaskDriver={getAssignedTaskDriver}
          formatTaskDuration={formatTaskDuration}
          formatAmount={formatAmount}
          getTaskStatusColor={getTaskStatusColor}
          formatDateTime={formatDateTime}
        />
      </>

      {renderModals()}
      <Dialog.Root open={statusConfirmOpen} onOpenChange={setStatusConfirmOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />

          <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[92%] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="border-b bg-gradient-to-r from-orange-50 to-white px-5 py-4">
              <Dialog.Title className="flex items-center gap-2 text-base font-semibold text-gray-900">
                <AlertTriangle
                  size={18}
                  className={
                    statusDriver?.status === "active"
                      ? "text-red-600"
                      : "text-green-600"
                  }
                />
                {statusDriver?.status === "active"
                  ? "Deactivate Driver"
                  : "Activate Driver"}
              </Dialog.Title>
            </div>

            <div className="px-5 py-4">
              <p className="text-sm text-gray-700">
                Are you sure you want to{" "}
                <span className="font-semibold">
                  {statusDriver?.status === "active"
                    ? "deactivate"
                    : "activate"}
                </span>{" "}
                this driver?
              </p>

              <div className="mt-3 rounded-xl border bg-gray-50 p-3 text-sm">
                <div className="font-semibold text-gray-900">
                  {statusDriver?.fullName || statusDriver?.username || "Driver"}
                </div>

                <div className="text-xs text-gray-500">
                  {statusDriver?.driverId || "-"} • Current Status:{" "}
                  {statusDriver?.status || "-"}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-2 border-t px-5 py-4">
              <button
                className="rounded-lg border px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                onClick={() => {
                  setStatusConfirmOpen(false);
                  setStatusDriver(null);
                }}
                disabled={statusSubmitting}
              >
                Cancel
              </button>

              <button
                className={`rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-60 ${
                  statusDriver?.status === "active"
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-green-600 hover:bg-green-700"
                }`}
                disabled={statusSubmitting}
                onClick={async () => {
                  if (!statusDriver) return;

                  setStatusSubmitting(true);
                  const success =
                    await deactivateActivateDriverApi(statusDriver);
                  setStatusSubmitting(false);

                  if (success) {
                    setStatusConfirmOpen(false);
                    setStatusDriver(null);
                  }
                }}
              >
                {statusSubmitting
                  ? "Updating..."
                  : statusDriver?.status === "active"
                    ? "Deactivate"
                    : "Activate"}
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      <PackerTaskConfigModal
        open={packerTaskConfigOpen}
        onOpenChange={setPackerTaskConfigOpen}
        drivers={drivers}
        getPackerTaskConfig={getPackerTaskConfig}
        savePackerTaskConfig={savePackerTaskConfig}
        onSuccess={() => {}}
      />
    </div>
  );
}
